<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Canteen Report</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <b>Academic Year</b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year"
              @change="putnull()" />
          </v-col>
          <v-col cols="12" sm="3">
            <b>Student Status </b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="stud_status" :items="status_list"
              item-text="name" item-value="id" label="Status" outlined persistent-hint @change="standard = []"
              hint="Please Select Status" />
          </v-col>
          <v-col cols="12" sm="3">
            <b>Standard </b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
              item-text="standard" item-value="id" label="Standard" outlined persistent-hint multiple
              hint="Please Select Standard" @change="fetchCanteenFeesRerort()" />
          </v-col>

        </v-row>
      </v-card>
      <v-card class="box" v-if="this.show_table == true">
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong> Canteen Report </strong>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line background-color="white"
            hide-details></v-text-field>
          <v-btn rounded color="white" class="ml-3" small outlined
            @click="fnExcelReport('my-table-id', 'CanteenReportSbpps')" :loading="loader"><v-icon
              color="white">mdi-export</v-icon>Export</v-btn>
        </v-toolbar>
        <br>
        <div id="my-table-id">
          <v-simple-table class="elevation-1">
            <template>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>PRN</th>
                  <th>Name</th>
                  <th>Contact No</th>
                  <th>Standard</th>
                  <th>Division</th>
                  <th colspan="6" v-for="(item, index) in canteen_installments" :key="index">
                    {{ item.name }}
                  </th>
                  <th colspan="2">Total</th>
                  <!-- <th colspan="2">Active/Non-Active</th> -->
                  <!-- <th colspan="2">Remark</th> -->
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>-</th>
                  <th>-</th>
                  <th>-</th>
                  <th>-</th>
                  <th>-</th>
                  <th>-</th>
                  <th v-for="(header, index) in canteen_installments.length * 6" :key="index">
                    <span v-if="header % 6 == 0">Cancel Date </span>
                    <span v-else-if="header % 6 == 1"> To Pay</span>
                    <span v-else-if="header % 6 == 2"> Paid Till Now </span>
                    <span v-else-if="header % 6 == 3"> Balance </span>
                    <span v-else-if="header % 6 == 4"> Joining Date</span>
                    <span v-else-if="header % 6 == 5">Active/Inactive </span>
                  </th>
                  <th>To Pay</th>
                  <th>Paid Till Now</th>
                  <!-- <th colspan="2">-</th> -->
                  <!-- <th colspan="2">-</th> -->
                </tr>
                <!-- <tr
                v-for="(item, index) in canteenFeesReportDetails"
                :key="index"
              > -->
                <!-- for search added line -->
                <tr v-for="(item, index) in filteredItems" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.registration_number }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.mobile_no }}</td>
                  <td>{{ item.standard }}</td>
                  <td>{{ item.division }}</td>
                  <td v-for="(
header, index
                    ) in item.learner_canteen_fees_installment_details" :key="index">
                    {{ header }}
                  </td>
                  <td>{{ item.total_to_pay }}</td>
                  <td>{{ item.total_paid }}</td>
                  <!-- <td colspan="2">{{ item.is_blocked_for_transport }}</td> -->
                  <!-- <td colspan="2">{{ item.blocked_for_transport_reason }}</td> -->
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    ay_list: [],
    ay: "",
    standard_list: [],
    status_list: [],
    standard: "",
    stud_status: '',
    show_table: false,
    canteenFeesReportDetails: [],
    canteen_installments: [],
    headers_list: [],
    search: "",
  }),
  computed: {
    filteredItems() {
      return this.canteenFeesReportDetails.filter((item) => {
        return (
          item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
          item.standard.toLowerCase().indexOf(this.search.toLowerCase()) > -1 || item.registration_number.toLowerCase().indexOf(this.search.toLowerCase()) > -1 || item.division.toLowerCase().indexOf(this.search.toLowerCase()) > -1 || item.mobile_no.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        );
      });
    },
  },

  methods: {
    putnull() {
      this.standard = "", this.canteenFeesReportDetails = [], this.headers_list = [], this.show_table = false
    },
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text =
        tab_text + "<table style='border-collapse:collapse;' border='1'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      exportTable.find("th, td").each(function () {
        $(this).css("border", "1px solid black");
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //     type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const filename = name + ".xls";

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    fetchCanteenFeesRerort() {

      if (!this.standard || this.standard.length === 0) {
        this.showSnackbar("red", "Please Select standard");
        this.overlay = false;
        return;
      }
      this.overlay = true;
      const data = {
        ay: this.ay,
        standard: this.standard,
        stud_status: this.stud_status
      };

      axios
        .post("Canteen/fetchCanteenFeesRerortSBPPS", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.canteenFeesReportDetails = res.data.canteenFeesReportDetails;
            this.canteen_installments = res.data.canteen_installments;
            if (this.canteen_installments.length <= 0 || this.canteenFeesReportDetails.length <= 0) {
              this.showSnackbar("red", "No Records Found...");
              return
            }
            this.headers_list = res.data.headers_list;
            this.show_table = true;
            this.overlay = false;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
            this.show_table = false;
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    onLoad() {
      axios
        .post("ParentTransport/TransportFeesReport")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            this.standard_list = res.data.standard_list;
            this.status_list = res.data.status_list;
            this.stud_status = this.status_list[1].id;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}

tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}

td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}

@media (min-width: 320px) {

  td,
  th {
    display: table-cell !important;
    font-size: small;
  }

  td+td,
  th+th {
    width: auto;
    font-size: small;
  }
}

v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
</style>